import Model from './Model'

export default class AuthenticationLog extends Model {
    resource()
    {
        return 'authentication-logs'
    }
}
